"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-next-line


var Key = function (_Component) {
  _inherits(Key, _Component);

  function Key() {
    _classCallCheck(this, Key);

    return _possibleConstructorReturn(this, (Key.__proto__ || Object.getPrototypeOf(Key)).apply(this, arguments));
  }

  _createClass(Key, [{
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Key;
}(_react.Component);

Key.propTypes = {
  // visit: https://css-tricks.com/snippets/javascript/javascript-keycodes/
  code: _propTypes.string.isRequired,
  onKeyMatch: _propTypes.func,
  name: _propTypes.string,
  shouldPreventDefault: _propTypes.bool
};
Key.defaultProps = {
  componentType: "Key",
  onKeyMatch: null,

  // if the keyboard is attached to an input field
  // will prevent the user from insert characters
  // to avoid this case you can use shouldPreventDefault
  shouldPreventDefault: true
};
exports.default = Key;